/// <reference path="../../typings/browser.d.ts" />
/// <reference path="../../customtypings/selectize/selectize.d.ts" />

namespace Application.Controllers {
    'use strict';

    interface ISelectOption {
        value: string;
        text: string;
    }

    /**
     * NetworkNodeController class
     */
    export class MobileDevicesController {
        public static $name: string = "mobileDevicesController";
        public static $inject: string[] = ['mobileDevicesService',
                                           '$scope',
                                           '$location',
                                           ];

        public networkNodes: Models.IPaginatedList<Models.INetworkNode>;
        public mobileDevices: Models.IPaginatedList<Models.MobileDevice>;

        public paginationSize: number;
        public paginationPage: number;

        private mobileDevicesService: Application.Services.MobileDevicesService;
        private $scope: ng.IScope;
        private $location: ng.ILocationService;
        private selectize: Selectize.IApi<number, ISelectOption>;

        /**
         * Constructor of the class.
         */
        constructor(mobileDevicesService: Application.Services.MobileDevicesService,
                    $scope: ng.IScope,
                    $location: ng.ILocationService) {
            this.$scope = $scope;
            this.$location = $location;
            this.mobileDevicesService = mobileDevicesService;

            this.selectize = undefined;
            this.paginationPage = 0;
            this.paginationSize = -1;
            this.loadMobileDevices().then(() => { this.loadSelectize(); });

            this.$scope.$on('$destroy', () => {
                if (this.selectize)
                    this.selectize.destroy();
            });
        }

        /**
         * Change the list view to another a given page.
         * @param {number} page - The page number to show
         */
        public changePageNumber(page: number): void {
            this.paginationPage = page;
            this.loadMobileDevices();
        }

        public navigateToDevice(mobileDevice: Models.MobileDevice): void {
            this.mobileDevicesService.setMobileDevice(mobileDevice);
            this.$location.path('/mobile-devices/' + Common.Utils.idFromHref(mobileDevice.networkNode.href));
        }

        private loadMobileDevices(): ng.IPromise<void> {
            let paginationSize: number = this.paginationSize === -1 ? 10 : this.paginationSize;
            return this.mobileDevicesService
                .getAllPaginatedMobileDevices(this.paginationPage, paginationSize, Models.NetworkNode.getDefaultOrderColumn())
                .then((res: Models.IPaginatedList<Models.MobileDevice>) => {
                    this.mobileDevices = res;
                    res.elements.forEach((mobileDevice: Models.MobileDevice) => {
                        this.updateRemainingTime(mobileDevice);
                    });
                });
        }

        private updateRemainingTime(mobileDevice: Models.MobileDevice): void {
            let dataAvailable: number = mobileDevice.totalRemainingData; // bytes
            if (typeof(mobileDevice.transmissionRate) !== 'number' || mobileDevice.transmissionRate < 0)
                mobileDevice.transmissionRate = 0;
            let transmissionRate: number = mobileDevice.transmissionRate * 1024 * 1024 * 8; // bits
            let transmissionTime: number = 8 * dataAvailable / transmissionRate;

            let hours: number = Math.floor(transmissionTime / 3600);
            transmissionTime %= 3600;
            let minutes: number = Math.floor(transmissionTime / 60);
            let seconds: number = Math.floor(transmissionTime % 60);

            if (hours > 0) {
                mobileDevice.totalRemainingTime = hours + "h " + minutes + "m  " + seconds + "s";
            } else {
                if (minutes > 0) {
                    mobileDevice.totalRemainingTime = minutes + "m  " + seconds + "s";
                } else {
                    mobileDevice.totalRemainingTime = seconds + "s ";
                }
            }

            if (mobileDevice.transmissionRate === 0)
                mobileDevice.totalRemainingTime = 'inf';
        }

        private loadSelectize(): void {
            if (this.selectize !== undefined)
                this.selectize.destroy();
            let $select: JQuery = $('#select-page-size').selectize({
                labelField: 'text',
                valueField: 'value',
                maxItems: 1,
                onChange: (paginationSize: number): void => {
                    let firstTime: boolean = this.paginationSize === -1;
                    this.paginationPage = 0;
                    this.paginationSize = paginationSize;
                    if (!firstTime) this.loadMobileDevices();
                },
                options: [
                    { value: 10, text: '10 nodes per page'},
                    { value: 20, text: '20 nodes per page'},
                    { value: 50, text: '50 nodes per page'},
                    { value: 100, text: '100 nodes per page'},
                ],
            });
            this.selectize = $select[0].selectize;
            this.selectize.setValue(10);
        }
    }
}